export class DocumentData {
	documentId: number;
	json: any;
	constructor() {
		this.documentId = 0;
	}
}
